import React, { Component } from "react";
import {
  Button,
  CircularProgress,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { styles } from "../Styles.css";
import CloseIcon from "@material-ui/icons/Close";
import withStyles from "@material-ui/core/styles/withStyles";
import { Translation } from "react-i18next";
import clsx from "clsx";
// import trackFields from "../../../../_module/definition/trackFields";
import {
  attachmentTypes,
  contentRequestStatus,
  contentRequestStatusList,
  contentRequestTypes,
  messageTypes,
} from "../../../messages/Const";
import { setSelectedItem } from "../../../../redux/actions/MLTrackUpdateAction";
// import albumFields from "../../../../_module/definition/albumFields";
import UserDisplay from "../../../../util/UserDisplay";

class LinkContentRequest extends Component {
  constructor(props) {
    super();
    this.state = {
      selectedItem: "",
    };
  }

  componentDidMount() {
    const {
      contentRequest: { query, linkContentMsg },
      linkCRequestSearch,
    } = this.props;
    linkCRequestSearch(linkContentMsg?.type || contentRequestTypes.TRACK_INSTRUMENTAL);
  }

  handleClose = () => {
    const { setLinkwithContentRequest, onClose } = this.props;
    setLinkwithContentRequest(null);
    // onClose();
  };

  handleChange = (event) => {
    this.setState({
      selectedItem: event.target.value,
    });
  };

  handleOpenContentRequest = (e) => {
    const {
      editMessage,
      setEditMessageCB,
      setLinkwithContentRequest,
      contentRequest: {
        linkContentMsg: { data, type },
      },
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _albumFields: albumFields
  
        }
      } 
    } = this.props;
    const { selectedItem } = this.state;
    e.stopPropagation();
    if (setSelectedItem) {
      setEditMessageCB(null);
      editMessage({
        id: selectedItem,
        type: messageTypes.CONTENT_REQUEST,
        attachments: [
          type === contentRequestTypes.ALBUM 
          ?
            {
              id: data.prodId,
              title: data[albumFields.prodName.id],
              artist: data[albumFields.prodArtist.id],
              artwork: data[albumFields.prodArtworkUrl.id],
              type: attachmentTypes.ALBUM,
            }
          :
            {
              id: data.id,
              title: data[trackFields.trackTitle.id],
              artist: data[trackFields.performer.id],
              artwork: data[trackFields.prodArtworkUrl.id],
              type: attachmentTypes.TRACK,
            }
        ],
        linkedId: type === contentRequestTypes.ALBUM ? data.prodId : data.id
      });
      setLinkwithContentRequest(null);
    }
  };

  render() {
    const {
      classes,
      contentRequest: {
        linkContentMsg,
        cRequestLoading,
        cRequestErrors,
        cRequestItems,
      },
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
  
        }
      } 
    } = this.props;

    const { selectedItem } = this.state;

    const getcStatusText = (status) => {
      let index = contentRequestStatusList.findIndex(
        (item) => item.id == status
      );
      if (index != -1) {
        return contentRequestStatusList[index].label;
      } else {
        return "N/A";
      }
    };

    return (
      <Translation>
        {(t, { i18n }) => (
          <>
          <Paper className={classes.sideBar} role="ContentRequest">
                       
              <Paper className={classes.disFlex}>
                                    <h2 className={classes.muTitle}>

                     Link With Content Request
                     <span  className={classes.muSubTitle}>
                      {" "}
                      {(linkContentMsg &&
                        linkContentMsg.data[trackFields?.trackTitle?.id]) ||
                        ""}
                    </span>
                     </h2>
                  
                 
                
                  <Button
                    className={clsx(
                      classes.commonTopButton,
                      classes.buttonCustomSize,
                      classes.globalGrayButton,
                      classes.closeRightButton,                  
                  )}
                    onClick={this.handleClose}
                    aria-label={t("messagesManager.close")}
                  >
                    <CloseIcon />
                  </Button>
                  </Paper>
                
                <div
                  className={classes.muListWrapUploads}
                  disabled={cRequestLoading}
                >
                  {cRequestLoading ? (
                    <CircularProgress
                      className={classes.circularProgressIconAsFeedback}
                    />
                  ) : cRequestItems.length === 0 ? (
                    <div className={classes.noResults}>No "Acknowledged" requests found</div>
                  ) : (
                    <> <div className={classes.albumDisplayList}>
                      <RadioGroup
                        aria-label="gender"
                        name="controlled-radio-buttons-group"
                        value={selectedItem}
                        onChange={this.handleChange}
                      >
                        {cRequestItems.filter((item)=>{ return item.attachments[0]?.contentType === linkContentMsg?.type}).map((message) => {
                          return (
                            <FormControlLabel
                              value={message.id}
                              control={<Radio />}
                              label={
                                <>
                                <span className={classes.reqName}>
                                  {message.attachments[0]?.title}
                                  <div><small> By <UserDisplay userId={message.createdBy} /> </small></div>
                                  </span>
                                  <div
                                    title={getcStatusText(message.cStatus)}
                                    className={clsx(
                                      classes.messagebodyDate,
                                      message.cStatus ==
                                        contentRequestStatus.REQUESTED
                                        ? classes.contentRequested
                                        : message.cStatus ==
                                          contentRequestStatus.ACKNOWLEDGED
                                        ? classes.contentAcknowledged
                                        : message.cStatus ==
                                          contentRequestStatus.SUCCESSFUL
                                        ? classes.contentSuccessful
                                        : message.cStatus ==
                                          contentRequestStatus.NOTSOURCED
                                        ? classes.contentNotsourced
                                        : null
                                    )}
                                  >
                                   {getcStatusText(message.cStatus)}
                                  </div>
                                  
                                </>
                              }
                            />
                          );
                        })}
                      </RadioGroup>
                      </div>
                      <Button
                        disabled={!selectedItem}
                        className={clsx(
                          classes.reqAddButton             
                          
                        )}
                        onClick={this.handleOpenContentRequest}
                        aria-label={"open content request"}
                      >
                        Open Content Request
                      </Button>
                      
                    </>
                  )}
                </div>
             
             
            </Paper>
          </>
        )}
      </Translation>
    );
  }
}


export default  (withStyles(styles)(LinkContentRequest));
